import Button from '@ben/orion/deprecated-button';
import { IconName } from '@ben/orion/icon';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { Link } from 'react-router-dom';
import { CenteredContainer } from '../shared/centered-container';

export function FallbackComponent() {
  return (
    <CenteredContainer>
      <Typography variant={TypographyVariant.bodyLg1}>
        An error has occurred
      </Typography>
      <Link to="/">
        <Button label="Go home" iconName={IconName.Home} />
      </Link>
    </CenteredContainer>
  );
}
